import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ClientList from '../ClientList';
import QuestionStats from './QuestionStats';
import EditIcon from '@material-ui/icons/Edit';
import MessageList from './MessageList';
import Badge from '@material-ui/core/Badge';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';


const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: '#222',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        marginRight: theme.spacing(1),
        '&:focus': {
            opacity: 1,
        },
    },
}))((props) => <Tab disableRipple {...props} />);
const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '& > div': {
            maxWidth: 40,
            width: '100%',
            backgroundColor: '#635ee7',
        },
    },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: '#1d1d1d',
    },
    badge: {
        marginLeft: 20
    }
}));

export default function QuestionTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    const { selectedQuestion, orderList } = props;
    return selectedQuestion.type === 'Option' ? (
        <div className={classes.root}>

            {orderList.length > 0 ?
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"

                >
                    <Tab style={{ color: value === 0 ? '#ffffffde' : '#ffffff99' }} label="Översikt" {...a11yProps(0)} />
                    <Tab style={{ color: value === 1 ? '#ffffffde' : '#ffffff99' }} label={<div>
                        <SystemLabel name="Voted" />
                        <Badge
                            classes={{ root: classes.badge }}
                            color="secondary"
                            badgeContent={orderList.filter(a => {
                                return props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
                            }).length}
                            showZero
                            max={1000}
                        ></Badge>
                    </div>} {...a11yProps(1)} />
                    <Tab style={{ color: value === 2 ? '#ffffffde' : '#ffffff99' }} label={<div>
                        <SystemLabel name="NotVoted" />
                        <Badge
                            classes={{ root: classes.badge }}
                            color="secondary"
                            badgeContent={orderList.filter(a => {
                                return !props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
                            }).length}
                            showZero
                            max={1000}
                        ></Badge>
                    </div>} {...a11yProps(2)} />

                </Tabs>
                : (
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab style={{ color: value === 0 ? '#ffffffde' : '#ffffff99' }} label="Översikt" {...a11yProps(0)} />
                    </Tabs>
                )
            }
            <TabPanel value={value} index={0}>
                <QuestionStats attendees={orderList} {...props} />
            </TabPanel>
            {
                orderList.length > 0 ? (
                    <React.Fragment>
                        <TabPanel value={value} index={1}>
                            <ClientList
                                orderList={orderList.filter(a => {
                                    return props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
                                })}
                                clientList={props.clientList} />
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <ClientList
                                orderList={orderList.filter(a => {
                                    return !props.clientResponses.map(c => { return c.clientKey }).includes(a.badgeNo)
                                })}
                                clientList={props.clientList} />
                        </TabPanel>
                    </React.Fragment>
                ) : null
            }
        </div >) : (
            <div className={classes.root}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab style={{ color: value === 0 ? '#ffffffde' : '#ffffff99' }} label="Opublicerat" {...a11yProps(0)} />
                    <Tab style={{ color: value === 1 ? '#ffffffde' : '#ffffff99' }} label="Publicerade" {...a11yProps(1)} />
                </Tabs>

                <TabPanel value={value} index={0}>
                    <MessageList status={1} {...props} />
                </TabPanel>
                <TabPanel value={value} index={1} >
                    <MessageList status={2} {...props} />
                </TabPanel>
            </div>
        );
}




